import type {
  AuditorUserFilter,
  EditAuditorUserInput,
  getAuditorUserQuery,
  getAuditorUsersQuery,
  InputMaybe,
  InsurerUsersOrderBy,
} from "../../remote/gql/graphql";
import type { ClientReturnType } from "../types";
import type { AlaffiaClientModuleArgs } from "./modules";

import { editAuditorUserMutationDoc } from "../../remote/mutations/editAuditorUser.gql";
import { getAuditorUserQueryDoc } from "../../remote/queries/getAuditorUser.gql";
import { getAuditorUsersQueryDoc } from "../../remote/queries/getAuditorUsers.gql";
import { AlaffiaClientModule } from "./modules";

type AuditorUsersModuleArgs = AlaffiaClientModuleArgs;

export class AuditorUsersModule extends AlaffiaClientModule {
  constructor(args: AuditorUsersModuleArgs) {
    super(args);
  }

  editAuditorUser = async (input: {
    id: string;
    editInput: EditAuditorUserInput;
  }) => {
    const result = await this.runGqlMutation(
      editAuditorUserMutationDoc,
      { userId: input.id, input: input.editInput },
      "editAuditorUser",
    );

    return {
      data: result.data?.editAuditorUser ?? null,
      error: result.error ?? null,
    };
  };

  getAuditorUser = async (input: {
    id: string;
    insurerUsersOrderBy?: InputMaybe<
      InsurerUsersOrderBy | InsurerUsersOrderBy[]
    >;
  }): ClientReturnType<getAuditorUserQuery["auditorUser"]> => {
    const result = await this.runGqlQuery(
      getAuditorUserQueryDoc,
      { id: input.id, insurerUsersOrderBy: input.insurerUsersOrderBy },
      "getAuditorUser",
    );
    return {
      data: result.data?.auditorUser ?? null,
      error: result.error ?? null,
    };
  };

  getAuditorUsers = async (input: {
    filter: AuditorUserFilter;
  }): ClientReturnType<getAuditorUsersQuery["auditorUsers"]> => {
    const result = await this.runGqlQuery(
      getAuditorUsersQueryDoc,
      { filter: input.filter },
      "getAuditorUsers",
    );
    return {
      data: result.data?.auditorUsers ?? null,
      error: result.error ?? null,
    };
  };
}
